import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSidebar = ({ currentLanguage }) => {
  const contactInfo = {
    phone: '+254 721 320 787',
    whatsapp: '+254721320787',
    email: 'info@peterpartnerslaw.co.ke',
    address: 'Nairobi, Kenya'
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I would like to inquire about your legal services.' :'Hujambo, ningependa kuuliza kuhusu huduma zenu za kisheria.');
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.open(`tel:${contactInfo.phone}`, '_self');
  };

  const legalInsights = [
    {
      id: 1,
      title: currentLanguage === 'en' ?'New Corporate Governance Regulations in Kenya' :'Kanuni Mpya za Utawala wa Makampuni Kenya',
      date: '2024-01-15',
      readTime: currentLanguage === 'en' ? '5 min read' : 'Soma kwa dakika 5'
    },
    {
      id: 2,
      title: currentLanguage === 'en' ?'Understanding Property Transfer Laws' :'Kuelewa Sheria za Uhamisho wa Mali',
      date: '2024-01-10',
      readTime: currentLanguage === 'en' ? '7 min read' : 'Soma kwa dakika 7'
    },
    {
      id: 3,
      title: currentLanguage === 'en' ?'Family Law Updates: Child Custody Guidelines' :'Masasisho ya Sheria ya Familia: Miongozo ya Ulinzi wa Watoto',
      date: '2024-01-05',
      readTime: currentLanguage === 'en' ? '4 min read' : 'Soma kwa dakika 4'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Quick Contact */}
      <div className="card p-6">
        <h3 className="font-heading font-semibold text-lg text-text-primary mb-4">
          {currentLanguage === 'en' ? 'Quick Contact' : 'Wasiliana Haraka'}
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
              <Icon name="Phone" size={16} className="text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">{contactInfo.phone}</p>
              <p className="text-xs text-text-secondary font-caption">
                {currentLanguage === 'en' ? 'Call us directly' : 'Tupigie moja kwa moja'}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-8 h-8 bg-success/10 rounded-lg">
              <Icon name="MessageCircle" size={16} className="text-success" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">WhatsApp</p>
              <p className="text-xs text-text-secondary font-caption">
                {currentLanguage === 'en' ? 'Instant consultation' : 'Ushauri wa haraka'}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-8 h-8 bg-accent/10 rounded-lg">
              <Icon name="Mail" size={16} className="text-accent" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">{contactInfo.email}</p>
              <p className="text-xs text-text-secondary font-caption">
                {currentLanguage === 'en' ? 'Email inquiry' : 'Uliza kwa barua pepe'}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-3">
          <Button
            variant="primary"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={handleWhatsAppClick}
          >
            {currentLanguage === 'en' ? 'WhatsApp Consultation' : 'Mazungumzo ya WhatsApp'}
          </Button>
          
          <Button
            variant="outline"
            fullWidth
            iconName="Phone"
            iconPosition="left"
            onClick={handleCallClick}
          >
            {currentLanguage === 'en' ? 'Call Now' : 'Piga Simu Sasa'}
          </Button>
        </div>
      </div>

      {/* Recent Legal Insights */}
      <div className="card p-6">
        <h3 className="font-heading font-semibold text-lg text-text-primary mb-4">
          {currentLanguage === 'en' ? 'Recent Legal Insights' : 'Maarifa ya Hivi Karibuni ya Kisheria'}
        </h3>
        
        <div className="space-y-4">
          {legalInsights.map((insight) => (
            <div key={insight.id} className="border-b border-border-light pb-4 last:border-b-0 last:pb-0">
              <h4 className="text-sm font-medium text-text-primary mb-2 leading-tight">
                {insight.title}
              </h4>
              <div className="flex items-center space-x-2 text-xs text-text-secondary font-caption">
                <Icon name="Calendar" size={12} />
                <span>{new Date(insight.date).toLocaleDateString()}</span>
                <span>•</span>
                <span>{insight.readTime}</span>
              </div>
            </div>
          ))}
        </div>

        <Button
          variant="ghost"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          className="mt-4"
        >
          {currentLanguage === 'en' ? 'View All Insights' : 'Ona Maarifa Yote'}
        </Button>
      </div>
    </div>
  );
};

export default ContactSidebar;